import { array, option, string } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { get, isEqual } from 'lodash/fp';
import { CommanderThunkDispatch, GetState, Payment } from '@mews-commander/types';
import { PaymentState } from '@mews-commander/data-access';
import { getCurrentEnterprisePaymentsByBillId } from '@mews-commander/legacy-entities/src/ducks/payments';
import { getServiceOrdersByIds } from '@mews-commander/legacy-entities/src/ducks';
import { fetchAccountsByIds } from '@mews-commander/legacy-entities/src/actions';

export const isPaymentVerifyingState = flow(get<Payment, 'state'>('state'), isEqual(PaymentState.Verifying));

/**
 * Given billIds, it searches through payments on bills and if any payments are linked
 * to a reservation owned by another account, it fetches those accounts.
 */
export const fetchLinkedReservationOwners =
    ({ billIds, accountId }: { billIds: string[]; accountId: string }) =>
    (dispatch: CommanderThunkDispatch, getState: GetState) => {
        const state = getState();
        const paymentsOnBillLinkedToOtherAccountsReservation = pipe(
            billIds,
            array.flatMap((billId) => getCurrentEnterprisePaymentsByBillId(state, { billId })),
            array.filterMap((payment) => (payment.serviceOrderId ? option.some(payment.serviceOrderId) : option.none)),
            (paymentServiceOrderIds) => getServiceOrdersByIds(state, { ids: paymentServiceOrderIds }),
            array.map((serviceOrder) => serviceOrder.data.value.ownerId),
            array.uniq(string.Eq),
            array.filter((ownerId) => ownerId !== accountId)
        );

        if (paymentsOnBillLinkedToOtherAccountsReservation.length) {
            void dispatch(fetchAccountsByIds({ accountIds: paymentsOnBillLinkedToOtherAccountsReservation }));
        }
    };
